import * as React from 'react';
import {IFiltersInput} from '../filter.interface';

export const FiltersInput = (props: IFiltersInput) => {
    const hasError = props.isInvalid?'error':'';
    const btnGroupClasses = `form-control ${hasError}`;
    const colName = props.colClassName ? props.colClassName : 'col-25';
    const enabled = props.readonly ? 'disabled' : '';
    const test = `${colName} ${enabled}`;
    const trimVal = (target:any) => {
        const ev = target;
        ev.currentTarget.value = String(ev.currentTarget.value).trim()
        return ev
    }
    if (props.type === 'number') {
        return (
            <div className={test}>
                <label className="filter-label">{props.label}</label>
                <input
                    id={props.id}
                    className={btnGroupClasses}
                    onChange={props.onChange}
                    onKeyUp={props.onKeyUp}
                    value={props.value}
                    type="number"
                    min="0"
                    ref={props.fRef}
                />
            </div>
        );
    }
    return (
        <div className={test}>
            <label className="filter-label">{props.label}</label>
            <input
                type={props.type}
                id={props.id}
                className={btnGroupClasses}
                placeholder={props.placeholder}
                onChange={props.onChange}
                onKeyUp={props.onKeyUp}
                onBlur={(e:any) => props.onChange ?props.onChange(trimVal(e)): ''}
                value={props.value}
                ref={props.fRef}
            />
        </div>
    );

}